/* global jQuery */
const $ = jQuery;

import "./woo-checkout";

import accordion from "./accordion";
import imageSlider from "./image-slider";
import imageSliderExpand from "./image-slider-expand";
import initProductCategoryForm from "./woo-product-categories";
import initSearchForm from "./faq-search";
import initStickyButton from "./sticky-button";
import initToggleSearch from "./toggle-search";
import initWooTablist from "./woo-tablist";
import productSummary from "./product-summary";
import showMore from "./show-more";

$(document).ready(() => {
  const $initProductCategoryForm = $(".js-product-category-form");
  if ($initProductCategoryForm.length) {
    $initProductCategoryForm.map((i, v) => initProductCategoryForm(v));
  }
  const $button = $(".js-buy-education");
  if ($button.length) {
    $button.map((i, v) => initStickyButton(v));
  }

  const $wooTablist = $(".js-tablist");
  if ($wooTablist.length) {
    $wooTablist.map((i, v) => initWooTablist(v));
  }

  const $productSummary = $(".js-product-summary-box");
  if ($productSummary.length) {
    $productSummary.map((i, v) => productSummary(v));
  }

  const $toggleSearchBtn = $(".header__search__button");
  if ($toggleSearchBtn.length) {
    initToggleSearch($toggleSearchBtn);
    initToggleSearch($(".nav-service__search__button"));
  }

  const $imageSliders = $(".carousel__wrapper");
  if ($imageSliders.length) {
    $imageSliders.map((_, el) => imageSlider(el));
  }
  const $imageSlidersModal = $(".carousel__wrapper--modal");
  if ($imageSlidersModal.length) {
    $imageSlidersModal.map((_, el) => imageSlider(el));
  }

  const $expand = $(".carousel__expand");
  if ($expand.length) {
    $expand.map((_, el) => imageSliderExpand(el));
  }

  const $accordions = $(".accordion__item__title");
  if ($accordions.length) {
    $accordions.map((_, el) => accordion(el));
  }

  const $showMore = $(".js-show-more");
  if ($showMore.length) {
    $showMore.map((_, el) => showMore(el));
  }

  const $initSearchForm = $(".js-faq-search");
  if ($initSearchForm.length) {
    $initSearchForm.map((_, el) => initSearchForm(el));
  }
});
